(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["why-collection"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('why-series')) {
    class WhySeries extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('[data-why-item]')];
        this.triggers = [...this.querySelectorAll('[data-why-trigger]')];
        this.media = [...this.querySelectorAll('[data-why-media]')];

        this.triggers.forEach((trigger, index) => {
          trigger.addEventListener('click', () => this.activate(index));
        });
      }

      activate(index) {
        this.items.forEach((item, i) => {
          const active = i === index;
          const panel = item.querySelector('.why-series__panel');
          item.classList.toggle('is-active', active);
          this.triggers[i].setAttribute('aria-expanded', String(active));
          panel.toggleAttribute('inert', !active);
          panel.setAttribute('aria-hidden', String(!active));
        });

        this.media.forEach((el) => {
          el.classList.toggle('is-active', Number(el.dataset.whyMedia) === index);
        });
      }
    }

    customElements.define('why-series', WhySeries);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["why-series"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('why-x-series')) {
    class WhyXSeries extends HTMLElement {
      connectedCallback() {
        this.img = this.querySelector('.wxs__img');
        this.items = [...this.querySelectorAll('details.wxs-item')];
        if (!this.items.length) return;

        if (this.img && !this.img.classList.contains('wxs__img--placeholder')) {
          this.defaultSrc = this.img.currentSrc || this.img.src;
          this.defaultSrcset = this.img.getAttribute('srcset');
        }

        // Ensure exactly one item starts open
        const open = this.items.filter((d) => d.open);
        if (!open.length) this.items[0].open = true;
        open.slice(1).forEach((d) => (d.open = false));

        this.items.forEach((d) => d.addEventListener('toggle', () => this.onToggle(d)));
        this.onToggle(this.items.find((d) => d.open));
      }

      onToggle(active) {
        if (!active) return;
        if (active.open) {
          // Fallback for browsers without <details name> exclusivity
          this.items.forEach((d) => { if (d !== active && d.open) d.open = false; });
          this.swapImage(active);
        } else if (!this.items.some((d) => d.open)) {
          // Keep one panel always open (matches design)
          active.open = true;
        }
      }

      swapImage(item) {
        if (!this.img || !this.defaultSrc) return;
        const src = item.dataset.imageSrc || this.defaultSrc;
        const srcset = item.dataset.imageSrcset || this.defaultSrcset;
        if (this.img.getAttribute('src') === src) return;
        this.img.classList.add('is-swapping');
        setTimeout(() => {
          this.img.src = src;
          if (srcset) this.img.setAttribute('srcset', srcset); else this.img.removeAttribute('srcset');
          this.img.classList.remove('is-swapping');
        }, 200);
      }
    }
    customElements.define('why-x-series', WhyXSeries);
  }
  } catch(e) { console.error(e); }
})();

})();
